import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Capacitor } from '@capacitor/core';
import { useConsent } from '../contexts/ConsentContext';
import { ENV_CONFIG } from '../config/environment';
import { loadAndInitMetaPixel, metaPixelSetConsent } from '../utils/metaPixel';

/**
 * Charge et initialise le Meta Pixel après consentement analytics (production web uniquement).
 */
const MetaPixelGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  useTranslation('common');
  const { consent } = useConsent();
  const { ENABLED, META_PIXEL_ID } = ENV_CONFIG.TRACKING;

  useEffect(() => {
    if (Capacitor.isNativePlatform() || !ENABLED) {
      return;
    }

    if (consent === 'granted') {
      loadAndInitMetaPixel(META_PIXEL_ID).catch(() => {
        // échec réseau / bloqueur : pas de throw pour ne pas casser l’app
      });
    } else if (consent === 'denied') {
      metaPixelSetConsent(false);
    }
  }, [consent, ENABLED, META_PIXEL_ID]);

  return <>{children}</>;
};

export default MetaPixelGate;
